<template lang="pug">
  div
    card-financeiro(
      cardTitle="Resumo"
    )
      template(slot="body")
        app-divider.margin-bottom-20(label=" Emissão do DAE", :showBorder="true")
        el-row.rowResumo
          el-col(:span="12")
            span.label Número do processo: &nbsp
            span {{ dadosDae.processoFisico.numero || '-' }}
          el-col(:span="12")
            span.label Telefone: &nbsp
            span {{ dadosDae.processoFisico.telefone || '-' }}
        el-row.rowResumo
          el-col(:span="12")
            span.label Nome/Razão social do interessado: &nbsp
            span {{ dadosDae.processoFisico.nomeRazaoSocialInteressado || '-' }}
          el-col(:span="12")
            span.label CPF/CPNJ do interessado: &nbsp
            span {{ dadosDae.processoFisico.cpfCnpjInteressado || '-' }}
        el-row.rowResumo
          el-col(:span="12")
            span.label Município: &nbsp
            span {{ dadosDae.processoFisico.endereco.municipio.nome || '-' }}
          el-col(:span="12")
            span.label Endereço: &nbsp
            span {{ getEndereco() }}

        app-divider.margin-bottom-20(:label="'Custas ' + (this.dadosDae.tipoCusta === 'PROCESSUAIS' ? 'processuais' : 'agrárias')", :showBorder="true")
        el-row.rowResumo
          el-table(
            :data="this.dadosDae.custas"
          )
            el-table-column(label="Discriminação", prop="tipoCusta.descricao", min-width="500")
            el-table-column(label="Quantidade", prop="quantidade", min-width="150")

        app-divider.margin-bottom-20(label=" Dados do DAE", :showBorder="true")
        el-row.rowResumo
          el-col(:span="12")
            span.label Receita: &nbsp
            span {{ dadosDae.tipoReceita.descricao || '-' }}
          el-col(:span="12")
            span.label Valor total: &nbsp
            span R$ {{ dadosDae.valorTotal | formatDouble }}
        el-row.rowResumo
          el-col(:span="8")
            span.label Data de vencimento: &nbsp
            span {{ formatarData(dadosDae.dataVencimento) }}
          el-col(:span="8")
            span.label Data do cálculo: &nbsp
            span {{ formatarData(dadosDae.dataCalculo) }}
          el-col(:span="8")
            span.label Referência: &nbsp
            span {{ formatarDataMesAno(dadosDae.dataReferencia) }}
        el-row.rowResumo
          el-col(:span="12")
            span.label Informações adicionais: &nbsp
            span {{ dadosDae.informacoesAdicionais || '-' }}

    app-buttons-cadastro(
      :isPrimeiroPasso="false",
      :isUltimoPasso="true",
      :showButtonSalvar="false",
      :isEtapaSalva="false",
      @cancelar="cancelar"
      @voltar="voltar",
      @finalizar="finalizar"
    )

</template>
<script>

import { mapActions } from 'vuex'
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Utils from '@/utils/utils'
import moment from 'moment'
import CardFinanceiro from '../components/CardFinanceiro'

export default {
  components: {
    AppDisplay,
    AppDivider,
    AppButtonsCadastro,
    CardFinanceiro
  },
  mixins: [
    AppNotificacao
  ],

  props: {
    processo: {
      type: Object
    }
  },

  async created () {
    this.montarDadosDae()
  },

  computed: {
    dadosDae () {
      return this.$route.params.dae
    }
  },

  methods: {
    ...mapActions({
      getTipoReceita: 'receitas/getTipoReceita',
      finalizarDae: 'dae/finalizar'
    }),
    async listTipoReceita () {
      await this.getTipoReceita(this.$route.params.dae.tipoReceita.id).then(tipoReceita => {
        this.dadosDae.tipoReceita = tipoReceita
      })
    },
    getEndereco () {
      return this.dadosDae.processoFisico.endereco.logradouro + ', ' +
            (this.dadosDae.processoFisico.endereco.semNumero === true ? 'S/N' : this.dadosDae.processoFisico.endereco.numero) +
            (this.dadosDae.processoFisico.endereco.complemento ? ', ' + this.dadosDae.processoFisico.endereco.complemento : '.')
    },
    montarDadosDae () {
      this.dae = {
        documentoOrigem: this.dadosDae.processoFisico.numero,
        periodoReferencia: moment(this.dadosDae.dataReferencia).format('YYYYMM'),
        isParcelado: false,
        dataVencimento: moment(this.dadosDae.dataVencimento).format('YYYY-MM-DD'),
        dataCalculo: moment(new Date()).format('YYYY-MM-DD'),
        valorPrincipal: this.dadosDae.valorTotal,
        valorMulta: this.dadosDae.valorMulta === 0 ? '0.0' : this.dadosDae.valorMulta,
        valorCorrecaoMonetaria: this.dadosDae.valorCorrecaoMonetaria === 0 ? '0.0' : this.dadosDae.valorCorrecaoMonetaria,
        valorAcrescimoMonetario: this.dadosDae.valorAcrescimosMonetarios === 0 ? '0.0' : this.dadosDae.valorAcrescimosMonetarios,
        valorTotal: this.dadosDae.valorTotal,
        informacoesAdicionais: this.dadosDae.informacoesAdicionais,
        nomeSolicitante: this.dadosDae.processoFisico.nomeRazaoSocialInteressado,
        identificacao: this.dadosDae.processoFisico.cpfCnpjInteressado,
        tipoIdentificacao: this.dadosDae.processoFisico.cpfCnpjInteressado.length === 14 ? 1 : 2,
        telefoneSolicitante: this.dadosDae.processoFisico.telefone,
        enderecoSolicitante: this.getEndereco(),
        codigoMunicipio: this.dadosDae.processoFisico.endereco.municipio.id,
        codigoReceita: this.dadosDae.tipoReceita.codigo,
        custas: this.dadosDae.custas
      }
    },

    async voltar () {
      this.$router.push({
        name: 'dae/cadastroDae',
        params: {
          numeroProcesso: this.dadosDae.processoFisico.numero,
          dae: this.dadosDae
        }
      })
    },
    formatarData (date) {
      return date !== null ? Utils.formatDate(date) : ' - '
    },
    formatarDataMesAno (date) {
      return date !== null ? Utils.formatDate(date, 'MM/YYYY') : ' - '
    },
    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'cof/visualizarProcessoFisico',
            params: {
              numeroProcesso: this.dadosDae.processoFisico.numero
            }
          })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    async finalizar () {
      try {
        await this.finalizarDae(this.dae)

        this.successNotification()

        this.$router.push({
          name: 'cof/visualizarProcessoFisico',
          params: {
            numeroProcesso: this.dadosDae.processoFisico.numero
          }
        })
      } catch (error) {
        this.errorNotification(error)

        throw error
      }
    },
    successNotification () {
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.DADOS_SALVOS_SUCESSO
      )
    },

    errorNotification (error) {
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        this.$messages.TITULO_ERROR,
        error.message
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.rowResumo {
  padding: 15px 0;
}
.label {
  font-weight: bold;
  padding-bottom: 10px;
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/dae/ResumoDae.vue